export default "__VITE_ASSET__DWj38Wf$__"